import { render } from "./complete.vue?vue&type=template&id=a4affa08"
import script from "./complete.vue?vue&type=script&lang=js"
export * from "./complete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__